import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab", "panel"]
    static classes = ["active", "inactive"]

    connect() {
        this.showTab(0)
    }

    change(event) {
        const index = this.tabTargets.indexOf(event.currentTarget)
        this.showTab(index)
    }

    showTab(index) {
        this.tabTargets.forEach((tab, i) => {
            if (i === index) {
                tab.classList.remove(...this.inactiveClasses)
                tab.classList.add(...this.activeClasses)
            } else {
                tab.classList.remove(...this.activeClasses)
                tab.classList.add(...this.inactiveClasses)
            }
        })

        this.panelTargets.forEach((panel, i) => {
            if (i === index) {
                panel.classList.remove("hidden")
            } else {
                panel.classList.add("hidden")
            }
        })
    }
}
